import styled from 'styled-components';

export const Timeline = styled.div`
  margin-bottom: 4px;
`;
